import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2 } from '@angular/core';
import { FileUploader } from './file-uploader';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[ng2FileSelect]',
    standalone: false
})
export class FileSelectDirective {
  @Input() public uploader: FileUploader;
  @Output() public onFileSelected: EventEmitter<File[]> = new EventEmitter<File[]>();

  constructor(private element: ElementRef, private renderer: Renderer2) {}

  @HostListener('change')
  public onChange(): void {
    const input: HTMLInputElement = this.element.nativeElement as HTMLInputElement;
    const files: FileList | null = input.files;
    if (!files || !files.length) {
      return;
    }
    const fileArray: File[] = Array.from(files);
    if (this.uploader) {
      this.uploader.addToQueue(fileArray);
    }
    this.onFileSelected.emit(fileArray);
  }

  public getOptions(): any {
    return this.uploader?.options ?? {};
  }
}
